import React from 'react';
import { BankAccountTypes } from '../../Enums/BankAccountType';
import { formatMessage } from '../../Localization/formatMessage';
import Messages from '../../Localization/Messages';
import './Styles.css';
import ErrorMessage from '../ErrorMessage';
import CustomRadioButton from '../ids/InputElements/RadioButton';

const BankAccountTypeSelector = ({ bankAccountType, onChange, errorMessage }) => {
  return (
    <>
      <label>{formatMessage(Messages.common_typeOfAccount)}</label>
      <div className="bank-account-type-container">
        {BankAccountTypes.keysValues.map(({ key, value }) => (
          <CustomRadioButton
            key={key}
            label={key}
            onChange={() => {
              onChange(value);
            }}
            checked={value === bankAccountType}
            id={`radio${key}`}
          />
        ))}
      </div>
      <ErrorMessage message={errorMessage} />
    </>
  );
};

export default BankAccountTypeSelector;
